<template>
  <div class="form-container">
    <h1>鳥獣被害詳細情報 {{ typeMapping[wildlifeData.type] }}</h1>
    <table v-if="wildlifeData" class="wildlife-list-detail-table">
      <tbody>
        <tr>
          <td><strong>受付番号</strong></td>
          <td><strong>:</strong></td>
          <td class="text">{{ wildlifeData.no }}</td>
        </tr>
        <tr>
          <td><strong>利用者ID</strong></td>
          <td><strong>:</strong></td>
          <td class="text">{{ wildlifeData.id }}</td>
        </tr>
        <tr>
          <td><strong>氏名</strong></td>
          <td><strong>:</strong></td>
          <td class="text">{{ wildlifeData.nameKanji }}</td>
        </tr>
        <tr>
          <td><strong>種別</strong></td>
          <td><strong>:</strong></td>
          <td class="text">{{ typeMapping[wildlifeData.type] }}</td>
        </tr>
        <tr>
          <td><strong>獣種</strong></td>
          <td><strong>:</strong></td>
          <td class="text">{{ animalTypeMapping[wildlifeData.animalType] }}</td>
        </tr>
        <tr>
          <td><strong>幼成獣別</strong></td>
          <td><strong>:</strong></td>
          <td class="text">{{ juvenileTypeMapping[wildlifeData.byAnimal] }}</td>
        </tr>
        <tr>
          <td><strong>確認場所</strong></td>
          <td><strong>:</strong></td>
          <td class="text">
            {{ wildlifeData.municipalities }}
            {{ wildlifeData.strAdd }}
          </td>
        </tr>
        <tr>
          <td><strong>日時</strong></td>
          <td><strong>:</strong></td>
          <td class="text">{{ formatDate(wildlifeData.damageDate) }}</td>
        </tr>
        <tr>
          <td><strong>頭数</strong></td>
          <td><strong>:</strong></td>
          <td class="text">{{ headCountTypeMapping[wildlifeData.count] }}</td>
        </tr>
        <tr>
          <td><strong>性別</strong></td>
          <td><strong>:</strong></td>
          <td class="text">{{ genderTypeMapping[wildlifeData.sex] }}</td>
        </tr>
        <tr v-if="isDamageType">
          <td><strong>被害面積(㎡)</strong></td>
          <td><strong>:</strong></td>
          <td class="text">{{ wildlifeData.damageArea }}</td>
        </tr>
        <tr v-if="isDamageType">
          <td><strong>被害金額(円)</strong></td>
          <td><strong>:</strong></td>
          <td class="text">{{ wildlifeData.damageAmount }}</td>
        </tr>
        <tr v-if="isSightType">
          <td><strong>体長(㎝)</strong></td>
          <td><strong>:</strong></td>
          <td class="text">{{ wildlifeData.length }}</td>
        </tr>
        <tr v-if="isSightType">
          <td><strong>体重(kg)</strong></td>
          <td><strong>:</strong></td>
          <td class="text">{{ wildlifeData.totalWeight }}</td>
        </tr>
        <!-- 画像データを表示 -->
        <tr v-for="(img, index) in imageUrls" :key="index">
          <td><strong>画像{{ index + 1 }}</strong></td>
          <td><strong>:</strong></td>
          <td class="text">
            <img :src="img" alt="画像{{ index + 1 }}" style="max-width: 100px; max-height: 100px;" />
          </td>
        </tr>
        <tr v-if="imageUrls.length === 0">
          <td><strong>画像</strong></td>
          <td><strong>:</strong></td>
          <td class="text">画像がありません</td>
        </tr>
        <tr>
          <td><strong>追記事項</strong></td>
          <td><strong>:</strong></td>
          <td class="text">{{ wildlifeData.addNote }}</td>
        </tr>
        <tr>
        <td><strong>緯度/経度</strong></td>
        <td><strong>:</strong></td>
        <td class="text">
          {{ wildlifeData.locationLat || '不明' }} /
          {{ wildlifeData.locationLon || '不明' }}
        </td>
        </tr>
        </tbody>
    </table>
    <p v-else>データを読み込めませんでした。</p>
    <div class="d-detail-button-group">
    <button @click="editRecord" class="update-button" :class="{ disabled: this.editButttonDisabeld }" v-bind:disabled="this.editButttonDisabeld">編集</button>
    <button @click="goBack" class="back-button">戻る</button>
    </div>
  </div>
</template>

<script>
import "@/assets/styles/Wildlife-detail-table.css";
export default {
  data() {
    const data = this.$route.query.data
      ? JSON.parse(decodeURIComponent(this.$route.query.data))[0]
      : null;
    return {
      wildlifeData: data || {},
      directAdminAgency: '',
      section: '',
      editButttonDisabeld: true,
      isDamageType: false,
      isSightType: false,
      typeMapping: {
        "1": "被害",
        "2": "捕獲",
        "3": "目撃",
        "4": "痕跡",
        "5": "わな",
        "9": "その他"
      },
      headCountTypeMapping: {
        "1" : "1", 
        "2" : "2", 
        "3" : "3", 
        "4" : "4", 
        "5" : "5以上", 
        "6" : "不明"
      },
      animalTypeMapping: {
        "01": "イノシシ",
        "02": "ニホンジカ",
        "03": "クマ",
        "04": "サル",
        "05": "タヌキ",
        "06": "アナグマ",
        "07": "ハクビシン",
        "08": "アライグマ",
        "09": "ヌートリア",
        "10": "鳥類",
        "11": "その他"
      },
      juvenileTypeMapping: {
        "1" : "幼獣", 
        "2" : "成獣", 
        "3" : "幼獣と成獣", 
        "4" : "不明"
      },
      genderTypeMapping: {
        "1" : "オス",
        "2" : "メス",
        "3" : "オスとメス",
        "4" : "不明",
      }
    };
  },
  computed: {
    imageUrls() {
      // wildlifeData内のキーを動的にチェックし、画像URLを配列として返す
      if (!this.wildlifeData) return [];
      return ["imageUrl", "imageUrl1", "imageUrl2"]
        .map(key => this.wildlifeData[key])
        .filter(url => url); // 空文字やundefinedを除外
    }
  },
  created() {
    console.log("Received wildlifeData:", this.wildlifeData);
    this.section = localStorage.getItem("section");
    this.directAdminAgency = localStorage.getItem("directAdminAgency");
    const userId = localStorage.getItem("userId");
  
    //「種別」が「被害」、「捕獲」、「目撃、痕跡」、その他」によって表示フラグを設定
    if (this.wildlifeData && this.wildlifeData.type === '1') {
      this.isDamageType = true;
    } else if (this.wildlifeData && this.wildlifeData.type === '2') {
      this.isSightType = true;
    }

    if (this.section === '0000') {
      // システム管理者は変更可能
      this.editButttonDisabeld = false;
    } else if (this.section === '0100' || this.section === '0101' || this.section === '0210') {
      // 行政機関管理者、行政機関メンバー、見える化管理者は変更可能
      this.editButttonDisabeld = false;
    } else {
      // それ以外は自分の登録されたデータだけが変更可能
      if (this.wildlifeData.id === userId) {
        this.editButttonDisabeld = false;
      }
    }
  },
  methods: {
    formatDate(dateStr) {
      // UTC日時から日本時間に変換
      const date = new Date(dateStr);

      // 日付が無効な場合の処理
      if (isNaN(date.getTime())) {
        return '不明'; // 無効な日付の場合の表示
      }

      // JST (UTC + 9時間)に変換
      date.setHours(date.getHours() + 9);

      // フォーマット: yyyy年MM月dd日 hh:mm
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');

      return `${year}年${month}月${day}日 ${hours}:${minutes}`;
    },
    goBack() {
      // ヒストリーに基づいて戻る
      this.$router.go(-1);

      // 状況に応じて、以下を補足的に入れることで確認可能
      const query = this.$route.query;
      console.log("Returning with query:", query);
    },
    editRecord() {
       this.$router.push({
      path: '/damageEdit', // 編集画面のルートパス
      query: { data: encodeURIComponent(JSON.stringify(this.wildlifeData)) }
      });
    }
  }
};
</script>

<style scoped>
.d-detail-button-group {
  display: flex;
  justify-content: center; /* ボタンを中央に配置 */
  margin-top: 20px; /* 上部余白を広げる */
}
</style>
